
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cadinu-lock",
      function () {
        return require("private-next-pages/cadinu-lock/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cadinu-lock"])
      });
    }
  